import { createSlice } from '@reduxjs/toolkit';
import { createKRA , fetchAllKRA ,fetchKRAById ,updateKRA ,deleteKRA} from './kraAction';
import { KRAState } from './kratypes';

const initialState : KRAState = {
    kra : [],
    selectedkra : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },

}

const kraSlice = createSlice({
    name : 'kra',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
            .addCase(createKRA.pending, (state) => {
                                              state.loadingStates.create = true;
                                              state.errors.create = undefined;
                                          })
                                          .addCase(createKRA.fulfilled, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.kra.push(action.payload);
                                          })
                                          .addCase(createKRA.rejected, (state, action) => {
                                              state.loadingStates.create = false;
                                              state.errors.create = action.payload as string;
                                          })
                              
                                          // Update 
                                          .addCase(updateKRA .pending, (state) => {
                                              state.loadingStates.update = true;
                                              state.errors.update = undefined;
                                          })
                                          .addCase(updateKRA .fulfilled, (state, action) => {
                                              state.loadingStates.update = false;
                                              const index = state.kra.findIndex((d : any) => d.Id === action.payload.Id);
                                              if (index !== -1) {
                                                  state.kra[index] = action.payload;
                                              }
                                          })
                                          .addCase(updateKRA .rejected, (state, action) => {
                                              state.loadingStates.update = false;
                                              state.errors.update = action.payload as string;
                                          })
                              
                                          // Delete 
                                          .addCase(deleteKRA.pending, (state) => {
                                              state.loadingStates.delete = true;
                                              state.errors.delete = undefined;
                                          })
                                          .addCase(deleteKRA.fulfilled, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.kra = state.kra.filter((d : any) => d.Id !== action.payload);
                                          })
                                          .addCase(deleteKRA.rejected, (state, action) => {
                                              state.loadingStates.delete = false;
                                              state.errors.delete = action.payload as string;
                                          })
                              
                                          // Fetch  by ID
                                          .addCase(fetchKRAById.pending, (state) => {
                                              state.loadingStates.fetchById = true;
                                              state.errors.fetchById = undefined;
                                          })
                                          .addCase(fetchKRAById.fulfilled, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.kra = action.payload;
                                          })
                                          .addCase(fetchKRAById.rejected, (state, action) => {
                                              state.loadingStates.fetchById = false;
                                              state.errors.fetchById = action.payload as string;
                                          })
                              
                                          // Fetch All 
                                          .addCase(fetchAllKRA.pending, (state) => {
                                              state.loadingStates.fetchAll = true;
                                              state.errors.fetchAll = undefined;
                                          })
                                          .addCase(fetchAllKRA.fulfilled, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.kra = action.payload.data;
                                          })
                                          .addCase(fetchAllKRA.rejected, (state, action) => {
                                              state.loadingStates.fetchAll = false;
                                              state.errors.fetchAll = action.payload as string;
                                          }); 
    }
})

export default kraSlice.reducer;